import { z } from "zod"

import * as m from "@/paraglide/messages"

const PHONE_REGEX = /^\+[1-9]\d{6,14}$/
const TAXPAYER_ID_REGEX = /^\d{5,10}$/

/** Strip every non-digit so the NIT is always a plain 5–10 digit number. */
export function sanitizeTaxpayerId(raw: string): string {
  return raw.replace(/\D/g, "")
}

export const userStepSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, m.signup_error_name_required())
      .max(100, m.signup_error_max_100()),
    lastName: z
      .string()
      .trim()
      .min(1, m.signup_error_lastName_required())
      .max(100, m.signup_error_max_100()),
    email: z
      .string()
      .trim()
      .min(1, m.signup_error_email_required())
      .pipe(z.email(m.signup_error_email_invalid())),
    password: z
      .string()
      .min(6, m.signup_error_password_min()),
    passwordConfirmation: z.string().min(1, m.signup_error_password_confirm_required()),
    phone: z
      .string()
      .trim()
      .optional()
      .refine(
        (value) => !value || PHONE_REGEX.test(value),
        m.signup_error_phone_format(),
      ),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: m.signup_error_password_mismatch(),
    path: ["passwordConfirmation"],
  })

export type UserStepValues = z.infer<typeof userStepSchema>

export const companyStepSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, m.signup_error_company_name_required())
    .max(100, m.signup_error_max_100()),
  taxpayerId: z
    .string()
    .transform(sanitizeTaxpayerId)
    .pipe(
      z
        .string()
        .min(1, m.signup_error_taxpayer_id_required())
        .regex(TAXPAYER_ID_REGEX, m.signup_error_taxpayer_id_format()),
    ),
})

export type CompanyStepValues = z.infer<typeof companyStepSchema>
